import Sidebar from '@space-core/components/sidebar'
import Icon from '@space-shell/common/components/icon'
import styled from 'styled-components'

export const CustomSidebar = styled(Sidebar)`
  --sidebar-width: 100%;
  --sidebar-close-display: none;
  --sidebar-border-width: 0;
`

CustomSidebar.displayName = 'CustomSidebar'

export const ContainerConfig = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  height: 100%;
  background-color: var(--bg-primary);
`

ContainerConfig.displayName = 'ContainerConfig'

export const ContainerHeaderBody = styled.div`
  display: grid;
  grid-template-rows: min-content auto;
`

ContainerHeaderBody.displayName = 'ContainerHeaderBody'

export const CustomIcon = styled(Icon)`
  width: 1.25rem;
  height: 1.25rem;
  margin: 0.625rem;
  &:hover {
    cursor: pointer;
  }
`

CustomIcon.displayName = 'CustomIcon'

export const ContainerSidebarContent = styled.div`
  max-height: 92vh;
`

ContainerSidebarContent.displayName = 'ContainerSidebarContent'
